import { render } from "@testing-library/react";
import React, { useState, ReactNode, useEffect, useCallback } from "react";
import "./Footer.less";
import events from "@/components/Joyspace/context/events";
import ReactDOM from "react-dom";
interface IProps {
  height?: number;
  footerRender?: () => ReactNode; // 自定义内容 组件传参
}
// let leftTree = 210;
const Footer = (props: IProps) => {
  const { footerRender, height = 50 } = props;
  const [left, setLeft] = useState(290); // 左侧 210 + 80
  // const [left, setLeft] = useState(leftTree + 80);
  const handelWidth = useCallback((width = "") => {
    setLeft(width + 80);
  }, []);
  useEffect(() => {
    const node: any = document.getElementById("joyspace-sidebar");
    if (node) {
      // eslint-disable-next-line radix
      setLeft(parseInt(node.style.width) + 80);
    }
  }, []);
  useEffect(() => {
    events.on("left-nav-resize", handelWidth);
    return () => {
      events.off("left-nav-resize", handelWidth);
    };
  }, [handelWidth]);
  return ReactDOM.createPortal(
    <div className="table-footer-box" style={{ height }}>
      <div className="table-footer">{footerRender?.()}</div>
    </div>,
    document.getElementById("joyspace-main-footer") || document.body
  );
};

export default Footer;
